var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65234 2.20312V4.45312",
    stroke: "#4B4AD5",
    strokeWidth: 1.24554,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6543 2.20312V4.45312",
    stroke: "#4B4AD5",
    strokeWidth: 1.24554,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27734 7.51953H16.0273",
    stroke: "#4B4AD5",
    strokeWidth: 1.24554,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0606 12.5313L12.4056 15.1863C12.3006 15.2913 12.2031 15.4863 12.1806 15.6288L12.0381 16.6413C11.9856 17.0088 12.2406 17.2638 12.6081 17.2113L13.6206 17.0688C13.7631 17.0463 13.9656 16.9488 14.0631 16.8438L16.7181 14.1888C17.1756 13.7313 17.3931 13.1988 16.7181 12.5238C16.0506 11.8563 15.5181 12.0738 15.0606 12.5313Z",
    stroke: "#4B4AD5",
    strokeWidth: 1.24554,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6777 12.9141C14.9027 13.7241 15.5327 14.3541 16.3427 14.5791",
    stroke: "#4B4AD5",
    strokeWidth: 1.24554,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6543 17.2031H6.6543C4.0293 17.2031 2.9043 15.7031 2.9043 13.4531V7.07812C2.9043 4.82812 4.0293 3.32812 6.6543 3.32812H12.6543C15.2793 3.32812 16.4043 4.82812 16.4043 7.07812V9.70312",
    stroke: "#4B4AD5",
    strokeWidth: 1.24554,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64822 10.9766H9.65496",
    stroke: "#4B4AD5",
    strokeWidth: 1.66071,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87479 10.9766H6.88152",
    stroke: "#4B4AD5",
    strokeWidth: 1.66071,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87479 13.2266H6.88152",
    stroke: "#4B4AD5",
    strokeWidth: 1.66071,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEdit);
export default __webpack_public_path__ + "static/media/calendar-edit.a7d786d190353453f570029841f70921.svg";
export { ForwardRef as ReactComponent };